import React from 'react'
import { PlanStatus } from '@/types/plan'

const statusStyles: Record<PlanStatus, string> = {
  draft: 'bg-yellow-100 text-yellow-700',
  active: 'bg-green-100 text-green-700',
  completed: 'bg-accent-100 text-accent-700'
}

const PlanStatusBadge: React.FC<{ status: PlanStatus }> = ({ status }) => (
  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${statusStyles[status] || 'bg-gray-100 text-gray-700'}`}>
    {status.toUpperCase()}
  </span>
)

export default PlanStatusBadge
